<script lang="ts">
    import { onMount } from "svelte";
    import KrankenwagenIcon from "../icons/KrankenwagenIcon.svelte";
    import IconImg from "./IconImg.svelte";
    import gsap from "gsap";
    import Animate from "./Animate.svelte";
    import Btn from "./Btn.svelte";
    import { fade, scale } from "svelte/transition";
    import BosIcon from "../icons/BosIcon.svelte";
    import MaritimIcon from "../icons/MaritimIcon.svelte";
    import OepnvIcon from "../icons/OEPNVIcon.svelte";
    import IndustrieIcon from "../icons/IndustrieIcon.svelte";
    import FlughafenIcon from "../icons/FlughafenIcon.svelte";
    import MailIcon from "../icons/MailIcon.svelte";
    import StadtwerkeIcon from "../icons/StadtwerkeIcon.svelte";
    import Mail2Icon from "../icons/Mail2Icon.svelte";
    import { t } from "../helpers/translation";
    type CircleInfo = {
        title: string;
        text: string;
        pos_id: string;
        icon: any;
        href?: string;
        open?: boolean;
        btn_text?: string;
    };

    let sinus_wave_container: HTMLElement;
    let sinus_wave_svg: HTMLElement | any;
    let sinus_wave_svg_back: HTMLElement | any;
    let sinus_wave_svg_front: HTMLElement | any;
    let green_wave: boolean = false;
    const lorem =
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex, praesentium facere repudiandae odio magnam ea.";

    let circleInfos: CircleInfo[] = [];

    $: circleInfos = [
        {
            title: $t("page.home.circleinfo.1.title"),
            text: $t("page.home.circleinfo.1.text"),
            pos_id: "pos_1",
            icon: BosIcon,
        },
        {
            title: $t("page.home.circleinfo.2.title"),
            text: $t("page.home.circleinfo.2.text"),
            pos_id: "pos_2",
            icon: StadtwerkeIcon,
        },
        {
            title: $t("page.home.circleinfo.3.title"),
            text: $t("page.home.circleinfo.3.text"),
            pos_id: "pos_3",
            icon: MaritimIcon,
        },
        {
            title: $t("page.home.circleinfo.4.title"),
            text: $t("page.home.circleinfo.4.text"),
            pos_id: "pos_4",
            icon: OepnvIcon,
        },
        {
            title: $t("page.home.circleinfo.5.title"),
            text: $t("page.home.circleinfo.5.text"),
            pos_id: "pos_5",
            icon: IndustrieIcon,
        },
        {
            title: $t("page.home.circleinfo.6.title"),
            text: $t("page.home.circleinfo.6.text"),
            pos_id: "pos_6",
            icon: FlughafenIcon,
        },
        {
            title: $t("page.home.circleinfo.7.title"),
            text: $t("page.home.circleinfo.7.text"),
            pos_id: "pos_7",
            icon: Mail2Icon,
            href: "javascript:window['openFCmodal']?.()",
            btn_text: $t("page.home.circleinfo.7.btn"),
        },
    ];

    function set_circle_positions() {
        const svg_size = sinus_wave_svg.viewBox.baseVal;
        const svg_height = svg_size.height;
        const svg_width = svg_size.width;

        for (const circle of circleInfos) {
            /* tslint:disable-next-line */
            const pos = document.getElementById(circle.pos_id);
            const circle_el = document.getElementById(
                "circle-info-" + circle.pos_id,
            );

            const new_pos_x = (pos.cx.baseVal.value / svg_width) * 100;
            const new_pos_y = (pos.cy.baseVal.value / svg_height) * 100;

            circle_el.style.top = new_pos_y + "%";
            circle_el.style.left = new_pos_x + "%";
        }
    }

    function animate_wave() {
        gsap.set(sinus_wave_svg_front, {
            strokeDashoffset: -sinus_wave_svg_front.getTotalLength(),
            strokeDasharray:
                sinus_wave_svg_front.getTotalLength() / 6 +
                ", " +
                sinus_wave_svg_front.getTotalLength(),
        });
        const tl = gsap.timeline({ yoyo: false, repeat: -1 });
        tl.to(sinus_wave_svg_front, {
            strokeDashoffset: sinus_wave_svg_front.getTotalLength() / 6,
            ease: "power1.inOut",
            ease: "linear",
            duration: 3,
        });
    }

    function on_circle_interaction(circle: CircleInfo, open: boolean) {
        circle.open = open;
        green_wave = open;
        console.log(open);
    }

    onMount(() => {
        set_circle_positions();
        animate_wave();
    });
</script>

<Animate scale_in duration={2.5}>
    <div class="sinus-wave-cta-container" bind:this={sinus_wave_container}>
        <svg
            bind:this={sinus_wave_svg}
            id="Ebene_2"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 483.9 231"
            ><g id="Ebene_2-2"
                ><g
                    ><path
                        bind:this={sinus_wave_svg_back}
                        id="curve_back"
                        d="M480.9,115.5c-37.82-53.51-76.03-107.02-119.3-107.02-86.55,0-152.05,214.04-238.61,214.04-43.54,0-81.75-54.16-119.99-107.99"
                    /><path
                        class:green_wave
                        bind:this={sinus_wave_svg_front}
                        id="curve_front"
                        d="M460.26,86.71c-31.2-42.37-63.24-78.24-98.67-78.24-86.55,0-152.05,214.04-238.61,214.04-36.83,0-69.86-38.76-102.31-83.3"
                    /><circle id="pos_1" cx="49.9" cy="177" r="8" /><circle
                        id="pos_2"
                        cx="119.9"
                        cy="223"
                        r="8"
                    /><circle id="pos_3" cx="193.9" cy="179" r="8" /><circle
                        id="pos_4"
                        cx="241.9"
                        cy="115"
                        r="8"
                    /><circle id="pos_5" cx="291.9" cy="49" r="8" /><circle
                        id="pos_6"
                        cx="361.9"
                        cy="8"
                        r="8"
                    /><circle id="pos_7" cx="426.9" cy="46" r="8" /><g
                        id="arrow_helper"
                        ><path
                            d="M95.9,150c12.99,14.23,24.44,14.99,28,15,19.21,.07,34.58-20.63,46-36,3.67-4.93,6.34-9.21,8-12"
                        /><polyline
                            points="171.88 119.41 177.9 117 178.26 123.14"
                        /></g
                    ></g
                ></g
            ></svg
        >

        <!-- ... -->
        <!-- ... -->
        <!-- ... -->
        <Animate children=".circle-info .inner" scale_in delay_each={0.3}>
            {#each circleInfos as circle (circle.pos_id)}
                <div
                    class="circle-info"
                    id={"circle-info-" + circle.pos_id}
                    style:z-index={circle.open ? "2000000" : null}
                    on:mouseenter={() => {
                        on_circle_interaction(circle, true);
                        circle = circle;
                        circle.open = true;
                    }}
                >
                    <div class="inner">
                        <IconImg svg={circle.icon} color="var(--yellow)" />
                    </div>
                    {#if circle.open}
                        <div
                            class="circle-info-popup"
                            transition:scale={{ duration: 550, start: 1.2 }}
                            on:mouseleave={() => {
                                on_circle_interaction(circle, false);
                                circle = circle;
                            }}
                        >
                            <div>
                                <span class="title">{circle.title}</span>
                                <span class="text">{circle.text}</span>
                                <div>
                                    {#if circle.href}
                                        <Btn small href={circle.href}
                                            >{circle.btn_text}</Btn
                                        >
                                    {/if}
                                </div>
                            </div>
                        </div>
                    {/if}
                </div>
            {/each}
        </Animate>
    </div>
</Animate>

<style lang="scss">
    @import "../src/vars";

    .sinus-wave-cta-container {
        position: relative;
        width: 100%;
        height: auto;

        @media (max-width: 700px) {
            display: none;
        }

        margin: 6rem 0;

        .circle-info {
            font-size: clamp(1.5rem, 5vw, 4rem);
            cursor: pointer;
            position: absolute;
            top: 0;
            left: 0;
            transform: translate(-50%, -50%);
            transition: 0.3s;
            &:hover {
                transform: translate(-50%, -50%) scale(1.2);
                .inner {
                    background-color: $grayDark;
                    box-shadow: 0 0 10px 5px rgba($yellow, 0.3);
                }
            }
            .inner {
                transition: 0.3s;
                width: 1.8em;
                height: 1.8em;
                padding: 0.3em;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 3000px;
                background-color: rgba(white, 0.8);
                background-color: rgba($grayDark, 0.9);
                border: 2px solid $yellow;
                backdrop-filter: blur(3px);
                position: relative;
            }
            .circle-info-popup {
                position: absolute;
                top: 50%;
                left: 50%;
                font-size: clamp(0.4rem, 1.2vw, 0.7rem);
                width: 18em;
                height: 18em;
                transform: translate(-50%, -50%);
                display: flex;
                align-items: center;
                justify-content: center;
                justify-items: center;
                // pointer-events: none;
                // opacity: 0;
                transition: 0.5s;
                background-color: rgba($grayDark2, 0.8);
                backdrop-filter: blur(3px);
                // border: 3px solid $yellow;
                box-shadow: 0 0 5px 5px rgba($yellow, 0.5);
                color: white;
                border-radius: 1000px;
                padding: 3em;
                text-align: center;
                .title {
                    display: block;
                    font-weight: 700;
                    margin-bottom: 1em;
                    font-size: 1.5em;
                }
                .text {
                    display: block;
                    margin-bottom: 1em;
                }
                // &.open {
                //     opacity: 1;
                //     pointer-events: all;
                // }
            }
        }

        svg {
            width: 100%;
            overflow: visible;

            circle {
                fill: none !important;
            }
            * {
                fill: none !important;
            }
            #curve_back,
            #curve_front {
                stroke-width: 0.5em;
                stroke: $gray2;
                stroke-linecap: round;
            }

            #curve_front {
                stroke: $yellow;
                transition: stroke 0.5s;
                &.green_wave {
                    stroke: $green;
                }
            }

            #arrow_helper {
                display: none !important;
                stroke: $gray2;
                stroke-width: 0.18em;
                stroke-linecap: round;
                stroke-linejoin: round;
            }
        }
    }
</style>
